// import axios from "../utils/axios";

// // Restaurant Auth APIs
// export const registerRestaurantApi = (data) =>
//   axios.post("/api/auth/register", data);

// export const loginRestaurantApi = (data) =>
//   axios.post("/api/auth/login", data);

// export const refreshTokenApi = () =>
//   axios.post("/api/auth/refresh");

// export const logoutApi = () =>
//   axios.get("/api/auth/logout");

// // Profile APIs
// export const getProfileApi = () =>
//   axios.get("/api/profile/me");

// export const updateProfileApi = (data) =>
//   axios.put("/api/profile/update", data);

// export const updatePasswordApi = (data) =>
//   axios.put("/api/profile/password/update", data);

// export const uploadProfileImageApi = (formData) =>
//   axios.put("/api/profile/upload-image", formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     },
//   });

// export const deleteProfileImageApi = () =>
//   axios.put("/api/v1/restaurant/delete-image");

import axios from "../utils/axios";

// Restaurant Auth APIs
export const registerRestaurantApi = (data) =>
  axios.post("/api/auth/register", data);

export const loginRestaurantApi = (data) =>
  axios.post("/api/auth/login", data);

export const refreshTokenApi = () =>
  axios.post("/api/auth/refresh");

export const logoutApi = () =>
  axios.get("/api/auth/logout");

// =============================================
// FORGOT PASSWORD - OTP APIs (ADD THESE)
// =============================================

/**
 * Send OTP to email for password reset
 * @param {string} email - User's email address
 */
export const forgotPasswordApi = (email) =>
  axios.post("/api/auth/forgot-password", { email });

/**
 * Verify OTP sent to email
 * @param {string} email - User's email address
 * @param {string} otp - 6-digit OTP
 */
export const verifyOTPApi = (email, otp) =>
  axios.post("/api/auth/verify-otp", { email, otp });

/**
 * Reset password with token
 * @param {string} resetToken - JWT token from OTP verification
 * @param {string} newPassword - New password (min 6 chars)
 */
export const resetPasswordApi = (resetToken, newPassword) =>
  axios.post("/api/auth/reset-password", { resetToken, newPassword });

/**
 * Resend OTP to email
 * @param {string} email - User's email address
 */
export const resendOTPApi = (email) =>
  axios.post("/api/auth/resend-otp", { email });

// Profile APIs
export const getProfileApi = () =>
  axios.get("/api/profile/me");

export const updateProfileApi = (data) =>
  axios.put("/api/profile/update", data);

export const updatePasswordApi = (data) =>
  axios.put("/api/profile/password/update", data);

export const uploadProfileImageApi = (formData) =>
  axios.put("/api/profile/upload-image", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const deleteProfileImageApi = () =>
  axios.put("/api/v1/restaurant/delete-image");
